import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"margin":"20px"} }
const _hoisted_2 = { style: {"width":"300px","display":"inline-block"} }
const _hoisted_3 = { style: {"margin":"20px"} }
const _hoisted_4 = { style: {"width":"300px","display":"inline-block"} }
const _hoisted_5 = { style: {"margin":"20px"} }
const _hoisted_6 = { style: {"width":"300px","display":"inline-block"} }

import { EventItem } from '@/models/event-item.model';
import { Initiative } from '@/models/initiative.model';
import { nameRules, Organization } from '@/models/organization.model';
import { User } from '@/models/user.model';
import { useEvents, Event } from '@/services/events.composable';
import { FilterData } from '@/services/users.service';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { ContentStoreActions, ContentStoreState } from '@/stores/content.store';
import { EventsActions, EventsState } from '@/stores/events.store';

import { UsersActions, UsersState } from '@/stores/users.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationForm',
  props: {
  data: {
    type: Object as PropType<Organization>,
    required: true,
  },
},
  setup(__props) {

const store = useStore<
  ShiftCMSState & { us: UsersState; cns: ContentStoreState; ev: EventsState }
>();

const events = useEvents();

const users = computed<User[]>(() => store.state.us.users);

const userOptions = computed(() =>
  users.value
    .filter((u) => !!u.firstName && !!u.lastName)
    .filter(
      (u) =>
        !(organization.value.users || []).map((u2) => u2.id).includes(u.id),
    )
    .map((v) => ({
      title: `${v.firstName} ${v.lastName} (id: ${v.id})`,
      value: v,
    })),
);
const initiatives = computed<Initiative[]>(() => store.state.cns.initiatives);

const initiativeOptions = computed(() =>
  initiatives.value
    .filter((u) => !!u.title)
    .filter(
      (u) => !organization.value.initiatives.map((u2) => u2.id).includes(u.id),
    )
    .map((v) => ({
      title: `${v.title} (id: ${v.id})`,
      value: v,
    })),
);

const eventItems = computed<EventItem[]>(() => store.state.ev.items);

const eventOptions = computed(() =>
  eventItems.value
    .filter((u) => !!u.title)
    .filter(
      (u) => !organization.value.initiatives.map((u2) => u2.id).includes(u.id),
    )
    .map((v) => ({
      title: `${v.title} (id: ${v.id})`,
      value: v,
    })),
);

const filterData = ref<FilterData>({
  search: '',
  level: null,
  page: 1,
  count: 25,
  sort: 'id',
  direction: 'asc',
});

function updateUsers(value: string) {
  filterData.value.search = value;
  store.dispatch(UsersActions.GetUserList, filterData.value);
}

const userToAdd = ref<User | null>(null);

function addUser() {
  if (userToAdd.value) {
    organization.value = {
      ...organization.value,
      users: [...organization.value.users, userToAdd.value],
    };

    userToAdd.value = null;
  }
}

const filterData2 = ref<FilterData>({
  search: '',
  level: null,
  page: 1,
  count: 25,
  sort: 'id',
  direction: 'asc',
});

function updateInitiatives(value: string) {
  filterData2.value.search = value;
  store.dispatch(
    ContentStoreActions.GetInitiativesPaginated,
    filterData2.value,
  );
}

const initiativeToAdd = ref<Initiative | null>(null);

function addInitiative() {
  if (initiativeToAdd.value) {
    organization.value = {
      ...organization.value,
      initiatives: [...organization.value.initiatives, initiativeToAdd.value],
    };

    initiativeToAdd.value = null;
  }
}

const filterData3 = ref<FilterData>({
  search: '',
  level: null,
  page: 1,
  count: 25,
  sort: 'id',
  direction: 'asc',
});

function updateEvents(value: string) {
  filterData3.value.search = value;
  store.dispatch(EventsActions.GetEventItemsPaginated, filterData3.value);
}

const eventToAdd = ref<EventItem | null>(null);

function addEvent() {
  if (eventToAdd.value) {
    organization.value = {
      ...organization.value,
      events: [...organization.value.events, eventToAdd.value],
    };

    eventToAdd.value = null;
  }
}
function removeUser(user: User) {
  organization.value.users = [
    ...organization.value.users.filter((v) => v.id !== user.id),
  ];
  return null;
}

function removeInitiative(initiative: Initiative) {
  organization.value.initiatives = [
    ...organization.value.initiatives.filter((v) => v.id !== initiative.id),
  ];
  return null;
}

function removeEvent(event: EventItem) {
  organization.value.events = [
    ...organization.value.events.filter((v) => v.id !== event.id),
  ];
  return null;
}

const props = __props;

const valid = ref<boolean>(false);

const organization = ref<Organization>({
  ...props.data,
});

const action = computed<string>(() =>
  organization.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveOrganization = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (organization.value.id === NEW_ID) {
      success = await store.dispatch(
        UsersActions.AddOrganization,
        organization.value,
      );
    } else {
      success = await store.dispatch(
        UsersActions.UpdateOrganization,
        organization.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved Organization',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(UsersActions.GetOrganizationsList);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save Organization',
      type: 'error',
    });
  }
};

onMounted(() => {
  if (props.data) {
    Object.assign(organization.value, {
      ...props.data,
    });
  }
});

const deleteOrganization = async () => {
  if (
    organization.value &&
    organization.value.id !== NEW_ID &&
    confirm('Are you absolutely sure you want to delete this "Organization"?')
  ) {
    store.dispatch(UsersActions.DeleteOrganization, organization.value);

    store.dispatch(UsersActions.GetOrganizationsList);
    store.commit(Mutations.HideDrawer);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveOrganization, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(action.value)) + " an organization", 1),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: organization.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((organization.value.name) = $event)),
                    label: "Name",
                    rules: _unref(nameRules)
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: organization.value.webToken,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((organization.value.webToken) = $event)),
                    label: "Web Token",
                    type: "password",
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_autocomplete, {
                    modelValue: userToAdd.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userToAdd).value = $event)),
                    items: userOptions.value,
                    "onUpdate:search": updateUsers,
                    label: "Add users"
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: addUser,
                    disabled: !userToAdd.value
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("Add user")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Users in this organization", -1)),
                      _createElementVNode("ul", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organization.value.users, (user) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: user.id
                          }, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
                            _createVNode(_component_v_btn, {
                              class: "mt-2",
                              type: "button",
                              color: "warning",
                              density: "compact",
                              icon: "mdi-delete-outline",
                              onClick: ($event: any) => (removeUser(user))
                            }, null, 8, ["onClick"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_autocomplete, {
                    modelValue: initiativeToAdd.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((initiativeToAdd).value = $event)),
                    items: initiativeOptions.value,
                    "onUpdate:search": updateInitiatives,
                    label: "Add places"
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: addInitiative,
                    disabled: !initiativeToAdd.value
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("Add place")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Places in this organization", -1)),
                      _createElementVNode("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organization.value.initiatives, (initiative) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: initiative.id
                          }, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(initiative.title), 1),
                            _createVNode(_component_v_btn, {
                              class: "mt-2",
                              type: "button",
                              color: "warning",
                              density: "compact",
                              icon: "mdi-delete-outline",
                              onClick: ($event: any) => (removeInitiative(initiative))
                            }, null, 8, ["onClick"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_autocomplete, {
                    modelValue: eventToAdd.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((eventToAdd).value = $event)),
                    items: eventOptions.value,
                    "onUpdate:search": updateEvents,
                    label: "Add events"
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: addEvent,
                    disabled: !eventToAdd.value
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("Add event")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Events in this organization", -1)),
                      _createElementVNode("ul", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organization.value.events, (event) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: event.id
                          }, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(event.title), 1),
                            _createVNode(_component_v_btn, {
                              class: "mt-2",
                              type: "button",
                              icon: "mdi-delete-outline",
                              color: "warning",
                              density: "compact",
                              onClick: ($event: any) => (removeEvent(event))
                            }, null, 8, ["onClick"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  (organization.value.id !== _unref(NEW_ID))
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "mt-2",
                        type: "button",
                        color: "warning",
                        density: "compact",
                        onClick: deleteOrganization,
                        block: ""
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("Delete")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})